import React from 'react';
import { Notifs } from 'redux-notifications';

export default class PageLayout extends React.Component {	

	render () {
	    return(
	    	<div>
				{this.props.children}
				<Notifs />
		    </div>);		
	}
	
}


/** WEBPACK FOOTER **
 ** ./js/layouts/PageLayout.js
 **/